import { render, staticRenderFns } from "./create-sales-order.vue?vue&type=template&id=7c16cb56&"
import script from "./create-sales-order.vue?vue&type=script&lang=ts&"
export * from "./create-sales-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports